import { Component } from '@angular/core';

@Component({
  selector: 'app-cards9-examples-57',
  templateUrl: './cards9-examples-57.component.html'
})
export class Cards9Examples57Component {}
